import React, { useState } from "react";
import Square from "./Square";
import "../frontend.css";

const SquareGrid = ({ array, setSelectedFrame }) => {
  const [highlightedIndex, setHighlightedIndex] = useState(0);

  const handleClick = (index, item) => {
    setHighlightedIndex(index);
    setSelectedFrame(item);
    // console.log(item);
  };

  return (
    <div className="square-grid">
      {/* {array.map((item, index) => (
        <Square
          key={index}
          highlighted={highlightedIndex === index}
          onClick={() => handleClick(index, item)}
          setSelectedFrame={setSelectedFrame}
        >
          <img src={item[0]} />
        </Square>
      ))} */}
    </div>
  );
};

export default SquareGrid;
